/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_WeedingInputs */

const vi_care_log_activity_weeding = /** @type {(inputs: Care_Log_Activity_WeedingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Làm cỏ`)
};

/**

* @param {Care_Log_Activity_WeedingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_weeding = /** @type {((inputs?: Care_Log_Activity_WeedingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_WeedingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_weeding(inputs)
});